import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import OrderCheckoutValidationCancellationPolicyForm from 'components/bookings/OrderCheckoutValidationCancellationPolicyForm'
import OrderCheckoutValidationShippingMethodForm from 'components/bookings/OrderCheckoutValidationShippingMethodForm'
import BabaForm from 'components/forms/Index'
import googleTracker from 'lib/trackers/googleTracker'
import NavigationButtons from 'components/bookings/NavigationButtons'
import CheckoutContext from 'components/bookings/contexts/CheckoutContext'

const OrderCheckoutValidation = ({
  order,
  urls,
  trackingInfo,
  onOrderModification,
  previousStepURL
}) => {
  const context = useContext(CheckoutContext)

  const handleContinue = () => {
    context.startLoading()
    if (context.handleValidationSuccessful) {
      context.handleValidationSuccessful()
    }
    if (trackingInfo) {
      googleTracker.trackValidatedCart(trackingInfo)
    }
    context.stopLoading()
  }

  const emailShippingMethod = {
    baseAmount: '0',
    code: 'email',
    headline: 'A imprimer chez soi',
    name: 'Email',
    selected: !order.shippingMethod,
    shippingAmount: '0'
  }
  const availableShippingMethods = [emailShippingMethod].concat(
    order.availableShippingMethods
  )

  return (
    <div
      className="checkout-validation"
      data-rspec="checkout-validation-container">
      <BabaForm.BabaForm onSubmit={handleContinue}>
        <div className="step-title">Vos options</div>

        {order.isGift && (
          <div className="mb-2">
            <div className="mb-2">Sélectionnez vos options cadeau</div>
            {availableShippingMethods.map((availableShippingMethod, index) => (
              <OrderCheckoutValidationShippingMethodForm
                key={index}
                shippingMethod={availableShippingMethod}
                onOrderModification={onOrderModification}
                shippingMethodUpdateURL={urls.shippingMethodUpdateURL}
                selectedShippingMethodCode={order.selectedShippingMethodCode}
              />
            ))}
          </div>
        )}

        {order.availableCancellationPolicies.map(
          (availableCancellationPolicy, index) => (
            <OrderCheckoutValidationCancellationPolicyForm
              key={index}
              cancellationPolicy={availableCancellationPolicy}
              onOrderModification={onOrderModification}
              updateCancellationPolicyUrl={urls.cancellationPolicyUpdateURL}
            />
          )
        )}

        <NavigationButtons
          priceAfter={order.priceAfter}
          goPrevious={context.goPrevious}
          submitLabel="Suivant"
          handleValidate={null}
          previousStepURL={previousStepURL}
        />
      </BabaForm.BabaForm>
    </div>
  )
}

OrderCheckoutValidation.propTypes = {
  order: PropTypes.shape({
    isGift: PropTypes.bool,
    shippingMethod: PropTypes.shape({
      code: PropTypes.string,
      label: PropTypes.string,
      amount: PropTypes.string,
      shippingDescription: PropTypes.string,
      shippingAmount: PropTypes.string
    }),
    availableShippingMethods: PropTypes.array.isRequired,
    availableCancellationPolicies: PropTypes.array.isRequired,
    selectedShippingMethodCode: PropTypes.string,
    priceAfter: PropTypes.string
  }).isRequired,
  urls: PropTypes.shape({
    shippingMethodUpdateURL: PropTypes.string.isRequired,
    cancellationPolicyUpdateURL: PropTypes.string.isRequired
  }).isRequired,
  trackingInfo: PropTypes.object,
  onOrderModification: PropTypes.func.isRequired,
  previousStepURL: PropTypes.string.isRequired
}

export default OrderCheckoutValidation
